import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { RecuperableModelError } from "@iot-platform/core";
import type { ConnectionAlertUpdate } from "@station/domain/models/connection-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ConnectionAlertUpdateUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(
        alertId: string,
        connectionAlert: ConnectionAlertUpdate,
    ): Promise<boolean> {
        const editResult = await this.alertRepository.updateConnectionAlert(
            alertId,
            connectionAlert,
        );

        return editResult.match(
            () => true,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return false;
                }

                ToastManagerRepository.error(error.message);

                return false;
            },
        );
    }
}
